import { useTranslation } from 'react-i18next'

import Button from '../../Button'
import { QA_NAME_CHATROOM_MESSAGE_LIKE } from '../Chatroom.constants'

import * as styles from './ChatroomMessageLike.module.css'

import LikeIcon from '../../../icons/like.svg'
import LikedIcon from '../../../icons/liked.svg'

function ChatroomMessageLike({ disabled, isLiked, likeCount, onClick }) {
  const { t } = useTranslation()

  const Icon = isLiked ? LikedIcon : LikeIcon

  const tooltip = isLiked
    ? t('Chatroom.MessageActionUnlikeTooltipKey')
    : t('Chatroom.MessageActionLikeTooltipKey')

  return (
    <Button.Text
      isGreySecondary
      beforeIconProps={{ Icon }}
      className={styles.chatroomMessageLike}
      disabled={disabled}
      qaName={QA_NAME_CHATROOM_MESSAGE_LIKE}
      text={String(likeCount)}
      tooltip={tooltip}
      onClick={onClick}
    />
  )
}

export default ChatroomMessageLike
